import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';

let getmanageschooldata = (schoolData) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'manageschool/getmanageschooldata', schoolData).then(result => {
            resolve(result)
        }).catch((err) => {

            if (err && err.response && err.response.data && err.response.data && err.response.data.message) {
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch report data"
                })
            }
        })
    })
}

const getAllCounty = async () => {
    return new Promise((resolve, reject) => {
        axios.get(config.basePath + `common/getallcounty?academicyear=${localStorage.getItem("academicyear")}`).then((result) => {
            resolve(result)
        }).catch((err) => {
            if (err && err.response && err.response.data && err.response.data && err.response.data.message) {
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch report data"
                })
            }
        })
    })
}

const addschool = async (schoolData) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'manageschool/addschool', schoolData).then((result) => {
            resolve(result)
        }).catch((err) => {
            if (err && err.response && err.response.data && err.response.data && err.response.data.message) {
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch report data"
                })
            }
        })
    })

}

const editschool = async (schoolData) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'manageschool/editschool', schoolData).then((result) => {
            resolve(result)
        }).catch((err) => {
            if (err && err.response && err.response.data && err.response.data && err.response.data.message) {
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch report data"
                })
            }
        })
    })

}

const deleteschool = async (schoolData) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'manageschool/deleteschool', schoolData).then((result) => {
            resolve(result)
        }).catch((err) => {
            if (err && err.response && err.response.data && err.response.data && err.response.data.message) {
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch report data"
                })
            }
        })
    })

}



const reportService = {
    getmanageschooldata,
    getAllCounty,
    addschool,
    editschool,
    deleteschool
}

export default reportService 